import React from 'react';
import { RelationIcon } from '../icons';

interface AIRelationManagerCardProps {
  selectedConnectionData: { phase?: string; phaseStatus?: string; } | null;
  relationManagerText: { title: string; body: string; helper?: string; toggleLabel?: string; };
  isAiRelationManagerEnabled: boolean;
  onToggle: () => void;
  isExpanded?: boolean;
}

const AIRelationManagerCard: React.FC<AIRelationManagerCardProps> = ({
  selectedConnectionData,
  relationManagerText,
  isAiRelationManagerEnabled,
  onToggle,
  isExpanded = true,
}) => {
  // Hide in physical-done state
  if (
    selectedConnectionData &&
    selectedConnectionData.phase === 'physical' &&
    (selectedConnectionData.phaseStatus === 'done' || selectedConnectionData.phaseStatus === 'completed')
  ) {
    return null;
  }

  // Only show when a connection is selected
  if (!selectedConnectionData) {
    return null;
  }

  if (!isExpanded) {
    return null;
  }

  return (
    <div className="mt-1.5 bg-gray-50 border border-gray-200 rounded-lg p-2 space-y-1.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-1.5">
          <RelationIcon size={14} weight="regular" className="text-gray-600" />
          <div>
            <div className="font-medium text-gray-700 text-xs">{relationManagerText.title}</div>
            {isAiRelationManagerEnabled && (
              <div className="text-[10px] text-emerald-600 flex items-center space-x-0.5">
                <span>✓</span>
                <span>Actief</span>
              </div>
            )}
          </div>
        </div>
        <button
          onClick={onToggle}
          className={`px-2 py-0.5 rounded text-[10px] font-medium transition-colors ${
            isAiRelationManagerEnabled
              ? 'bg-emerald-600 text-white hover:bg-emerald-700'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          {isAiRelationManagerEnabled ? 'Uit' : 'Inschakelen'}
        </button>
      </div>
      <p className="text-xs text-gray-600">{relationManagerText.body}</p>
      {relationManagerText.helper && (
        <p className="text-[10px] text-gray-500">{relationManagerText.helper}</p>
      )}
    </div>
  );
};

export default AIRelationManagerCard;





